import * as React from "react";
const SvgCopyPaste = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.625 1.871v.941H2.812v14.631h5.904V15.936H4.312l.002-5.811.001-5.81.657-.003.654-.001V6.192h7.123l.004-.938.002-.94H14.059l.004 1.737.002 1.734h1.498V2.812h-2.815v-.94h-3.56ZM7.123 3.38h4.129v1.307H7.123V4.03Zm3.188 5.99v12.759h10.877V9.37h-5.44zm1.507 1.508h7.871v9.744h-7.871v-4.873zm2.994 2.246v1.508h3.283v-1.508h-1.64zm-1.41 3.754v1.498h4.694v-1.498h-2.348z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgCopyPaste;
